export const SPORTS_GALLERY=[
  {
    "displayText": "21",
    "filename": "./assets/img/gallery/sports/21.JPG",
    "link": ""
  },
  {
    "displayText": "SPORT",
    "filename": "./assets/img/gallery/sports/SPORT.jpeg",
    "link": ""
  }
]